import React, { useEffect } from 'react'

const Home = () => {

    useEffect(() => {
        document.title = 'Arya Rizky Tri Putra'
    }, []);

    return <section className='text-light container mx-auto h-screen flex  justify-center mt-24 px-5'>
        <div className='relative'>
            <p className='mb-3 text-sm'>Hi👋, &nbsp; I am a</p>
            <h1 className='font-black text-3xl md:text-5xl mb-3'>Arya Rizky Tri Putra</h1>
            <p className='mb-5  text-sm'>A <span className='text-danger'>Fullstack Developer</span> with 5 years
                experience👨‍💻(Expert in Frontend web development with Nuxt.js).</p>
            <h3 className='font-bold mb-3  text-sm'>Connect with me</h3>
            <div className='flex gap-x-5 absolute'>
                <a className='hover:text-danger cursor-pointer'
                    href="https://id.linkedin.com/in/arya-rizky-tri-putra-9372961a2" target="_blank">
                    <i className=" fa-brands fa-linkedin"></i>
                </a>
                <a className='hover:text-danger cursor-pointer' href="https://github.com/Aryaak" target="_blank">
                    <i className=" fa-brands fa-github"></i>
                </a>
                <a className='hover:text-danger cursor-pointer' href="https://www.facebook.com/aryarizky.aryarizky.94"
                    target="_blank">
                    <i className=" fa-brands fa-facebook"></i>
                </a>
                <a className='hover:text-danger cursor-pointer' href="https://twitter.com/susahsemangat" target="_blank">
                    <i className=" fa-brands fa-twitter"></i>
                </a>
            </div>
        </div>
    </section>
}

export default Home